"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ServiceNow AI Toolkit
 * ServiceNow AI Toolkit API
 *
 * The version of the OpenAPI document:
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobApi = exports.JobApiFactory = exports.JobApiFp = exports.JobApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * JobApi - axios parameter creator
 * @export
 */
const JobApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get jobs in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobGet: (accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [accountId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (accountId, limit, offset, order, permission, q, human, recursive, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountJobGet', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/job`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create job in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobSpec} [jobSpec]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobPost: (accountId_1, human_1, jobSpec_1, ...args_1) => __awaiter(this, [accountId_1, human_1, jobSpec_1, ...args_1], void 0, function* (accountId, human, jobSpec, options = {}) {
            // verify required parameter 'accountId' is not null or undefined
            (0, common_1.assertParamExists)('v1AccountJobPost', 'accountId', accountId);
            const localVarPath = `/v1/account/{account_id}/job`
                .replace(`{${"account_id"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(jobSpec, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/cluster/job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update bid of the job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobRebid} [jobRebid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobBidPut: (jobId_1, human_1, jobRebid_1, ...args_1) => __awaiter(this, [jobId_1, human_1, jobRebid_1, ...args_1], void 0, function* (jobId, human, jobRebid, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobBidPut', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/bid`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(jobRebid, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get process agent children of the job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobChildrenGet: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobChildrenGet', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/children`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check if job is consented
         * @param {string} jobId The ID or fullname associated to the job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobConsentHead: (jobId_1, ...args_1) => __awaiter(this, [jobId_1, ...args_1], void 0, function* (jobId, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobConsentHead', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/consent`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Consent to job scopes
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobConsentPost: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobConsentPost', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/consent`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Cancel (a.k.a. kill) a queued, queuing or running job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobDeleteById: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobDeleteById', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Execute a command in a running job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobExecGet: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobExecGet', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/exec`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get job information
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobGetById: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobGetById', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check access to the job
         * @param {string} jobId The ID or fullname of the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobHeadById: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobHeadById', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'HEAD' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return logs of a job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [follow] WebSocket will continue to receive new logs if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobLogsGet: (jobId_1, follow_1, ...args_1) => __awaiter(this, [jobId_1, follow_1, ...args_1], void 0, function* (jobId, follow, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobLogsGet', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/logs`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (follow !== undefined) {
                localVarQueryParameter['follow'] = follow;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return logs of a job for a given run
         * @param {string} jobId The ID or fullname associated to the job
         * @param {string} runId ID of the run
         * @param {number} [follow] WebSocket will continue to receive new logs if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobLogsRunGet: (jobId_1, runId_1, follow_1, ...args_1) => __awaiter(this, [jobId_1, runId_1, follow_1, ...args_1], void 0, function* (jobId, runId, follow, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobLogsRunGet', 'jobId', jobId);
            // verify required parameter 'runId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobLogsRunGet', 'runId', runId);
            const localVarPath = `/v1/job/{job_id}/logs/{run_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (follow !== undefined) {
                localVarQueryParameter['follow'] = follow;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update job info like name, owner, etc
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {Job} [job]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobPutById: (jobId_1, human_1, job_1, ...args_1) => __awaiter(this, [jobId_1, human_1, job_1, ...args_1], void 0, function* (jobId, human, job, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobPutById', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(job, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retry an interrupted, failed or cancelled job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobRetryPut: (jobId_1, human_1, ...args_1) => __awaiter(this, [jobId_1, human_1, ...args_1], void 0, function* (jobId, human, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('v1JobRetryPut', 'jobId', jobId);
            const localVarPath = `/v1/job/{job_id}/retry`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs created by your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, options = {}) {
            const localVarPath = `/v1/me/job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobGet: (organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [organizationId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (organizationId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('v1OrganizationJobGet', 'organizationId', organizationId);
            const localVarPath = `/v1/organization/{organization_id}/job`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs created by the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobGet: (roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [roleId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (roleId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'roleId' is not null or undefined
            (0, common_1.assertParamExists)('v1RoleJobGet', 'roleId', roleId);
            const localVarPath = `/v1/role/{role_id}/job`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs created by the service
         * @param {string} serviceId The ID or fullname of the service
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceJobGet: (serviceId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [serviceId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (serviceId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'serviceId' is not null or undefined
            (0, common_1.assertParamExists)('v1ServiceJobGet', 'serviceId', serviceId);
            const localVarPath = `/v1/service/{service_id}/job`
                .replace(`{${"service_id"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create job on your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobSpec} [jobSpec]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutJobPost: (human_1, jobSpec_1, ...args_1) => __awaiter(this, [human_1, jobSpec_1, ...args_1], void 0, function* (human, jobSpec, options = {}) {
            const localVarPath = `/v1/job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(jobSpec, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs in your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutJobGet: (limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1) => __awaiter(this, [limit_1, offset_1, order_1, permission_1, q_1, human_1, recursive_1, ...args_1], void 0, function* (limit, offset, order, permission, q, human, recursive, options = {}) {
            const localVarPath = `/v1/job`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get jobs created by the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobGet: (userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1) => __awaiter(this, [userId_1, limit_1, offset_1, order_1, permission_1, q_1, human_1, ...args_1], void 0, function* (userId, limit, offset, order, permission, q, human, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1UserJobGet', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}/job`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (human !== undefined) {
                localVarQueryParameter['human'] = human;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.JobApiAxiosParamCreator = JobApiAxiosParamCreator;
/**
 * JobApi - functional programming interface
 * @export
 */
const JobApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.JobApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get jobs in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobGet(accountId, limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountJobGet(accountId, limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1AccountJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create job in the account
         * @param {string} accountId The ID or fullname of the account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobSpec} [jobSpec]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobPost(accountId, human, jobSpec, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AccountJobPost(accountId, human, jobSpec, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1AccountJobPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs in the cluster
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ClusterJobGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1ClusterJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update bid of the job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobRebid} [jobRebid]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobBidPut(jobId, human, jobRebid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobBidPut(jobId, human, jobRebid, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1JobBidPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get process agent children of the job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobChildrenGet(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobChildrenGet(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1JobChildrenGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check if job is consented
         * @param {string} jobId The ID or fullname associated to the job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobConsentHead(jobId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobConsentHead(jobId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1JobConsentHead']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Consent to job scopes
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobConsentPost(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobConsentPost(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1JobConsentPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Cancel (a.k.a. kill) a queued, queuing or running job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobDeleteById(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobDeleteById(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1JobDeleteById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Execute a command in a running job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobExecGet(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobExecGet(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1JobExecGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get job information
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobGetById(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobGetById(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1JobGetById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Check access to the job
         * @param {string} jobId The ID or fullname of the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobHeadById(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobHeadById(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1JobHeadById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Return logs of a job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [follow] WebSocket will continue to receive new logs if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobLogsGet(jobId, follow, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobLogsGet(jobId, follow, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1JobLogsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Return logs of a job for a given run
         * @param {string} jobId The ID or fullname associated to the job
         * @param {string} runId ID of the run
         * @param {number} [follow] WebSocket will continue to receive new logs if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobLogsRunGet(jobId, runId, follow, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobLogsRunGet(jobId, runId, follow, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1JobLogsRunGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update job info like name, owner, etc
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {Job} [job]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobPutById(jobId, human, job, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobPutById(jobId, human, job, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1JobPutById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Retry an interrupted, failed or cancelled job
         * @param {string} jobId The ID or fullname associated to the job
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobRetryPut(jobId, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1JobRetryPut(jobId, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1JobRetryPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs created by your user/role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobGet(limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1MeJobGet(limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1MeJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs in the organization
         * @param {string} organizationId The ID or fullname of the organization
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobGet(organizationId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1OrganizationJobGet(organizationId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1OrganizationJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs created by the role
         * @param {string} roleId The ID or fullname of the role
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobGet(roleId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RoleJobGet(roleId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1RoleJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs created by the service
         * @param {string} serviceId The ID or fullname of the service
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceJobGet(serviceId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ServiceJobGet(serviceId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1ServiceJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create job on your account
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {JobSpec} [jobSpec]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutJobPost(human, jobSpec, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShorcutJobPost(human, jobSpec, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1ShorcutJobPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs in your account
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {number} [recursive] Turns on recursive results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutJobGet(limit, offset, order, permission, q, human, recursive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ShortcutJobGet(limit, offset, order, permission, q, human, recursive, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1ShortcutJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get jobs created by the user
         * @param {string} userId The ID or fullname of the user
         * @param {number} [limit] Maximum number of data objects to return
         * @param {number} [offset] Number of items to skip before returning the results.
         * @param {string} [order] Order for the results.
         * @param {string} [permission] Filtering the items on which this action is allowed.
         * @param {string} [q] Filtering query.
         * @param {number} [human] Turns on fields pretty output if set to 1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobGet(userId, limit, offset, order, permission, q, human, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1UserJobGet(userId, limit, offset, order, permission, q, human, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['JobApi.v1UserJobGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.JobApiFp = JobApiFp;
/**
 * JobApi - factory interface
 * @export
 */
const JobApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.JobApiFp)(configuration);
    return {
        /**
         *
         * @summary Get jobs in the account
         * @param {JobApiV1AccountJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobGet(requestParameters, options) {
            return localVarFp.v1AccountJobGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create job in the account
         * @param {JobApiV1AccountJobPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AccountJobPost(requestParameters, options) {
            return localVarFp.v1AccountJobPost(requestParameters.accountId, requestParameters.human, requestParameters.jobSpec, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs in the cluster
         * @param {JobApiV1ClusterJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ClusterJobGet(requestParameters = {}, options) {
            return localVarFp.v1ClusterJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update bid of the job
         * @param {JobApiV1JobBidPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobBidPut(requestParameters, options) {
            return localVarFp.v1JobBidPut(requestParameters.jobId, requestParameters.human, requestParameters.jobRebid, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get process agent children of the job
         * @param {JobApiV1JobChildrenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobChildrenGet(requestParameters, options) {
            return localVarFp.v1JobChildrenGet(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check if job is consented
         * @param {JobApiV1JobConsentHeadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobConsentHead(requestParameters, options) {
            return localVarFp.v1JobConsentHead(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Consent to job scopes
         * @param {JobApiV1JobConsentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobConsentPost(requestParameters, options) {
            return localVarFp.v1JobConsentPost(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel (a.k.a. kill) a queued, queuing or running job
         * @param {JobApiV1JobDeleteByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobDeleteById(requestParameters, options) {
            return localVarFp.v1JobDeleteById(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Execute a command in a running job
         * @param {JobApiV1JobExecGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobExecGet(requestParameters, options) {
            return localVarFp.v1JobExecGet(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get job information
         * @param {JobApiV1JobGetByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobGetById(requestParameters, options) {
            return localVarFp.v1JobGetById(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check access to the job
         * @param {JobApiV1JobHeadByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobHeadById(requestParameters, options) {
            return localVarFp.v1JobHeadById(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return logs of a job
         * @param {JobApiV1JobLogsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobLogsGet(requestParameters, options) {
            return localVarFp.v1JobLogsGet(requestParameters.jobId, requestParameters.follow, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return logs of a job for a given run
         * @param {JobApiV1JobLogsRunGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobLogsRunGet(requestParameters, options) {
            return localVarFp.v1JobLogsRunGet(requestParameters.jobId, requestParameters.runId, requestParameters.follow, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update job info like name, owner, etc
         * @param {JobApiV1JobPutByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobPutById(requestParameters, options) {
            return localVarFp.v1JobPutById(requestParameters.jobId, requestParameters.human, requestParameters.job, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retry an interrupted, failed or cancelled job
         * @param {JobApiV1JobRetryPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1JobRetryPut(requestParameters, options) {
            return localVarFp.v1JobRetryPut(requestParameters.jobId, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs created by your user/role
         * @param {JobApiV1MeJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MeJobGet(requestParameters = {}, options) {
            return localVarFp.v1MeJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs in the organization
         * @param {JobApiV1OrganizationJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1OrganizationJobGet(requestParameters, options) {
            return localVarFp.v1OrganizationJobGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs created by the role
         * @param {JobApiV1RoleJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RoleJobGet(requestParameters, options) {
            return localVarFp.v1RoleJobGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs created by the service
         * @param {JobApiV1ServiceJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ServiceJobGet(requestParameters, options) {
            return localVarFp.v1ServiceJobGet(requestParameters.serviceId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create job on your account
         * @param {JobApiV1ShorcutJobPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShorcutJobPost(requestParameters = {}, options) {
            return localVarFp.v1ShorcutJobPost(requestParameters.human, requestParameters.jobSpec, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs in your account
         * @param {JobApiV1ShortcutJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ShortcutJobGet(requestParameters = {}, options) {
            return localVarFp.v1ShortcutJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get jobs created by the user
         * @param {JobApiV1UserJobGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserJobGet(requestParameters, options) {
            return localVarFp.v1UserJobGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(axios, basePath));
        },
    };
};
exports.JobApiFactory = JobApiFactory;
/**
 * JobApi - object-oriented interface
 * @export
 * @class JobApi
 * @extends {BaseAPI}
 */
class JobApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get jobs in the account
     * @param {JobApiV1AccountJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1AccountJobGet(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1AccountJobGet(requestParameters.accountId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create job in the account
     * @param {JobApiV1AccountJobPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1AccountJobPost(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1AccountJobPost(requestParameters.accountId, requestParameters.human, requestParameters.jobSpec, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs in the cluster
     * @param {JobApiV1ClusterJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1ClusterJobGet(requestParameters = {}, options) {
        return (0, exports.JobApiFp)(this.configuration).v1ClusterJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update bid of the job
     * @param {JobApiV1JobBidPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1JobBidPut(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1JobBidPut(requestParameters.jobId, requestParameters.human, requestParameters.jobRebid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get process agent children of the job
     * @param {JobApiV1JobChildrenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1JobChildrenGet(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1JobChildrenGet(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check if job is consented
     * @param {JobApiV1JobConsentHeadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1JobConsentHead(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1JobConsentHead(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Consent to job scopes
     * @param {JobApiV1JobConsentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1JobConsentPost(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1JobConsentPost(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Cancel (a.k.a. kill) a queued, queuing or running job
     * @param {JobApiV1JobDeleteByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1JobDeleteById(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1JobDeleteById(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Execute a command in a running job
     * @param {JobApiV1JobExecGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1JobExecGet(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1JobExecGet(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get job information
     * @param {JobApiV1JobGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1JobGetById(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1JobGetById(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check access to the job
     * @param {JobApiV1JobHeadByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1JobHeadById(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1JobHeadById(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return logs of a job
     * @param {JobApiV1JobLogsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1JobLogsGet(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1JobLogsGet(requestParameters.jobId, requestParameters.follow, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return logs of a job for a given run
     * @param {JobApiV1JobLogsRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1JobLogsRunGet(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1JobLogsRunGet(requestParameters.jobId, requestParameters.runId, requestParameters.follow, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update job info like name, owner, etc
     * @param {JobApiV1JobPutByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1JobPutById(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1JobPutById(requestParameters.jobId, requestParameters.human, requestParameters.job, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retry an interrupted, failed or cancelled job
     * @param {JobApiV1JobRetryPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1JobRetryPut(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1JobRetryPut(requestParameters.jobId, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs created by your user/role
     * @param {JobApiV1MeJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1MeJobGet(requestParameters = {}, options) {
        return (0, exports.JobApiFp)(this.configuration).v1MeJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs in the organization
     * @param {JobApiV1OrganizationJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1OrganizationJobGet(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1OrganizationJobGet(requestParameters.organizationId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs created by the role
     * @param {JobApiV1RoleJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1RoleJobGet(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1RoleJobGet(requestParameters.roleId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs created by the service
     * @param {JobApiV1ServiceJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1ServiceJobGet(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1ServiceJobGet(requestParameters.serviceId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create job on your account
     * @param {JobApiV1ShorcutJobPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1ShorcutJobPost(requestParameters = {}, options) {
        return (0, exports.JobApiFp)(this.configuration).v1ShorcutJobPost(requestParameters.human, requestParameters.jobSpec, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs in your account
     * @param {JobApiV1ShortcutJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1ShortcutJobGet(requestParameters = {}, options) {
        return (0, exports.JobApiFp)(this.configuration).v1ShortcutJobGet(requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get jobs created by the user
     * @param {JobApiV1UserJobGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobApi
     */
    v1UserJobGet(requestParameters, options) {
        return (0, exports.JobApiFp)(this.configuration).v1UserJobGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.permission, requestParameters.q, requestParameters.human, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.JobApi = JobApi;
